module.exports = __webpack_public_path__ + "img/A_New_Home.049aaf87.jpg";